export const frontendURI = '/cat/checklist_templates/';
export const backendURI = `/api${frontendURI}`;
